import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { C } from '../../design/tokens';

const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1h-2z" />
  </svg>
);

const ToolsIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);

const QuoteIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l7 4v6c0 5-3 8-7 10-4-2-7-5-7-10V6l7-4z" />
  </svg>
);

const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
);

const MeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="4" />
    <path d="M5 21c0-4.4 3.1-8 7-8s7 3.6 7 8" />
  </svg>
);

const TABS = [
  { path: '/dashboard', label: 'Home', Icon: HomeIcon },
  { path: '/tools', label: 'Tools', Icon: ToolsIcon },
  { path: '/quote', label: 'Quote', Icon: QuoteIcon },
  { path: '/book', label: 'Book', Icon: CalendarIcon },
  { path: '/panel/profile', label: 'Me', Icon: MeIcon },
];

function MobileNav({ currentPath }) {
  const location = useLocation();
  const activePath = currentPath || location.pathname;

  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: 56,
        background: '#fff',
        borderTop: '1px solid ' + C.border,
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
        boxSizing: 'content-box',
        fontFamily: "'Outfit', sans-serif",
      }}
    >
      {TABS.map((tab) => {
        const isActive = activePath === tab.path || activePath.startsWith(tab.path + '/');
        const color = isActive ? C.blue : C.textMuted;

        return (
          <Link
            key={tab.path}
            to={tab.path}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 1,
              textDecoration: 'none',
              padding: '6px 0',
              cursor: 'pointer',
            }}
          >
            <span
              style={{
                width: 20,
                height: 20,
                color: color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <tab.Icon />
            </span>
            <span
              style={{
                fontSize: 8,
                color: color,
                fontWeight: isActive ? 600 : 400,
                marginTop: 2,
                lineHeight: 1,
              }}
            >
              {tab.label}
            </span>
            {isActive && (
              <span style={{
                width: 4, height: 4, borderRadius: '50%', background: C.blue,
                marginTop: 2,
              }} />
            )}
          </Link>
        );
      })}
    </nav>
  );
}

export default MobileNav;
